<template>
  <svg class="base-icon" :viewBox="viewBox" fill="none" aria-hidden="true">
    <template v-if="name === 'bell'">
      <path d="M12 4a4 4 0 0 1 4 4v1.5c0 .8.24 1.58.68 2.24l1.12 1.68c.67 1 .03 2.33-1.17 2.33H7.37c-1.2 0-1.84-1.33-1.17-2.33l1.12-1.68A4 4 0 0 0 8 9.5V8a4 4 0 0 1 4-4Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10 18a2 2 0 0 0 4 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </template>
    <template v-else-if="name === 'arrow-right'">
      <path d="M5 12h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <path d="m13 6 6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </template>
    <template v-else-if="name === 'steam'">
      <path d="M11 11.5 7.2 14a2.8 2.8 0 1 0 1.62 2.56l3.7-2.44A4.8 4.8 0 1 0 11 11.5Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      <circle cx="16.5" cy="8.5" r="2.7" stroke="currentColor" stroke-width="1.8" />
    </template>
    <template v-else-if="name === 'qr'">
      <path d="M4 9V5.5A1.5 1.5 0 0 1 5.5 4H9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <path d="M15 4h3.5A1.5 1.5 0 0 1 20 5.5V9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <path d="M20 15v3.5a1.5 1.5 0 0 1-1.5 1.5H15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <path d="M9 20H5.5A1.5 1.5 0 0 1 4 18.5V15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <rect x="7" y="7" width="3" height="3" rx=".4" fill="currentColor" />
      <rect x="14" y="7" width="3" height="3" rx=".4" fill="currentColor" />
      <rect x="7" y="14" width="3" height="3" rx=".4" fill="currentColor" />
      <path d="M14 14h1.5v1.5H17V17h-3v-3Z" fill="currentColor" />
    </template>
    <template v-else-if="name === 'wallet'">
      <path d="M4 8.5A2.5 2.5 0 0 1 6.5 6H18a2 2 0 0 1 2 2v1.5H15.5a2.5 2.5 0 0 0 0 5H20V16a2 2 0 0 1-2 2H6.5A2.5 2.5 0 0 1 4 15.5v-7Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
      <path d="M15.5 9.5H21v5h-5.5a2.5 2.5 0 0 1 0-5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
      <circle cx="16.8" cy="12" r=".9" fill="currentColor" />
    </template>
    <template v-else-if="name === 'locker'">
      <rect x="6" y="4" width="12" height="16" rx="2" stroke="currentColor" stroke-width="1.8" />
      <path d="M10 8h4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <path d="M14 13v3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </template>
    <template v-else-if="name === 'cart'">
      <path d="M4 6h2l2 9h8l2-6H8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      <circle cx="10" cy="19" r="1" fill="currentColor" />
      <circle cx="17" cy="19" r="1" fill="currentColor" />
    </template>
    <template v-else-if="name === 'calendar'">
      <rect x="4" y="6" width="16" height="14" rx="3" stroke="currentColor" stroke-width="1.8" />
      <path d="M8 3v5M16 3v5M4 10h16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </template>
    <template v-else-if="name === 'clock'">
      <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.8" />
      <path d="M12 8v4l3 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </template>
    <template v-else-if="name === 'users'">
      <path d="M16.5 18a4 4 0 0 0-9 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="12" cy="9" r="3" stroke="currentColor" stroke-width="1.8" />
      <path d="M19 17.5a3.2 3.2 0 0 0-2.15-2.94" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <path d="M16.3 6.8a3 3 0 0 1 .7 5.92" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </template>
    <template v-else-if="name === 'image'">
      <rect x="4" y="5" width="16" height="14" rx="3" stroke="currentColor" stroke-width="1.8" />
      <circle cx="9" cy="10" r="1.5" fill="currentColor" />
      <path d="m7 17 4-4 3 3 2-2 3 3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </template>
    <template v-else-if="name === 'shield'">
      <path d="M12 3 6 5v5c0 4.42 2.56 8.48 6 10 3.44-1.52 6-5.58 6-10V5l-6-2Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
      <path d="m9.5 12 1.7 1.7 3.3-3.7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </template>
    <template v-else-if="name === 'menu'">
      <path d="M5 7h14M5 12h14M5 17h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </template>
    <template v-else-if="name === 'home'">
      <path d="M4.5 11.5 12 5l7.5 6.5V19a1 1 0 0 1-1 1H5.5a1 1 0 0 1-1-1v-7.5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
      <path d="M9.5 20v-6h5v6" stroke="currentColor" stroke-width="1.8" />
    </template>
    <template v-else-if="name === 'search'">
      <circle cx="11" cy="11" r="6" stroke="currentColor" stroke-width="1.8" />
      <path d="m16 16 4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </template>
    <template v-else-if="name === 'ticket'">
      <path d="M4 9a2 2 0 0 0 0 4v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3a2 2 0 1 0 0-4V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
      <path d="M12 7v10" stroke="currentColor" stroke-width="1.8" stroke-dasharray="1.8 2.2" stroke-linecap="round" />
    </template>
    <template v-else-if="name === 'plus'">
      <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </template>
    <template v-else-if="name === 'user'">
      <circle cx="12" cy="8.5" r="3.5" stroke="currentColor" stroke-width="1.8" />
      <path d="M5 19a7 7 0 0 1 14 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </template>
    <template v-else-if="name === 'logout'">
      <path d="M10 6H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <path d="M14 8l4 4-4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M18 12h-8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
    </template>
    <template v-else-if="name === 'settings'">
      <path d="M12 8.7a3.3 3.3 0 1 0 0 6.6 3.3 3.3 0 0 0 0-6.6Z" stroke="currentColor" stroke-width="1.8" />
      <path d="M19.4 15.1a1 1 0 0 0 .2 1.1l.1.1a1.9 1.9 0 0 1 0 2.7 1.9 1.9 0 0 1-2.7 0l-.1-.1a1 1 0 0 0-1.1-.2 1 1 0 0 0-.6.9V20a2 2 0 0 1-2 2h-1.4a2 2 0 0 1-2-2v-.2a1 1 0 0 0-.6-.9 1 1 0 0 0-1.1.2l-.1.1a1.9 1.9 0 0 1-2.7 0 1.9 1.9 0 0 1 0-2.7l.1-.1a1 1 0 0 0 .2-1.1 1 1 0 0 0-.9-.6H4a2 2 0 0 1-2-2v-1.4a2 2 0 0 1 2-2h.2a1 1 0 0 0 .9-.6 1 1 0 0 0-.2-1.1l-.1-.1a1.9 1.9 0 0 1 0-2.7 1.9 1.9 0 0 1 2.7 0l.1.1a1 1 0 0 0 1.1.2 1 1 0 0 0 .6-.9V4a2 2 0 0 1 2-2h1.4a2 2 0 0 1 2 2v.2a1 1 0 0 0 .6.9 1 1 0 0 0 1.1-.2l.1-.1a1.9 1.9 0 0 1 2.7 0 1.9 1.9 0 0 1 0 2.7l-.1.1a1 1 0 0 0-.2 1.1 1 1 0 0 0 .9.6H20a2 2 0 0 1 2 2v1.4a2 2 0 0 1-2 2h-.2a1 1 0 0 0-.9.6Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </template>
    <template v-else>
      <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.8" />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'BaseIcon',
  props: {
    name: {
      type: String,
      default: 'circle',
    },
  },
  computed: {
    viewBox() {
      return '0 0 24 24';
    },
  },
};
</script>

<style scoped src="./BaseIcon.css"></style>
